module.exports = __webpack_public_path__ + "static/media/bg.6168f5f1.jpg";